import { Check, LoaderCircle } from "lucide-react";

import { type Conversation } from "shared/apiClient";
import { ConversationPhase } from "shared/types";
import { getText, interpolate } from "shared/lib";

import { TimeLine } from "shared/components";

export interface AnalysisTimelineProps {
  conversation: Conversation | undefined | null;
  isPublic?: boolean;
}

export function AnalysisTimeline({
  conversation,
  isPublic,
}: AnalysisTimelineProps) {
  const userEmail = conversation?.user_email || "";

  const isReportComplete =
    conversation?.phase === ConversationPhase.sent_to_council;

  const renderCompletedTimeline = () => {
    return (
      <TimeLine
        items={[
          {
            content: <>{getText("Completed.")}</>,
            disabled: true,
            icon: <Check className="h-3 w-3" />,
            title: <>{getText("Draft")}</>,
          },
          {
            content: (
              <>
                {getText(
                  "The analysis has now been reviewed by myLot's AI. The review has improved the quality of the analysis, however, the information provided by this service is still a guide only and is not an official planning decision.",
                )}
              </>
            ),
            icon: <Check className="h-3 w-3" />,
            title: <>{getText("AI reviewed")}</>,
          },
        ]}
      />
    );
  };

  const renderDraftTimeline = () => {
    return (
      <TimeLine
        items={[
          {
            content: (
              <>
                {getText(
                  "The below analysis is a draft. It is now in myLot's AI queue and will be reviewed soon. Even after the AI review, remember that the information provided by this service is a guide only and is not an official planning decision.",
                )}
              </>
            ),
            icon: <Check className="h-3 w-3" />,
            title: <>{getText("Draft")}</>,
          },
          {
            content: (
              <>
                {interpolate(
                  "Underway. We'll send an email to {{userEmail}} when the review is complete.",
                  {
                    userEmail: <b>{userEmail}</b>,
                  },
                )}
              </>
            ),
            disabled: true,
            icon: <LoaderCircle className="h-3 w-3 animate-spin" />,
            title: <>{getText("AI reviewed")}</>,
          },
        ]}
      />
    );
  };

  if (isPublic) {
    if (isReportComplete) {
      return renderCompletedTimeline();
    }
    return;
  }

  if (isReportComplete) {
    return renderCompletedTimeline();
  }

  return renderDraftTimeline();
}
